<template>
  <div class="out-wrap">
    <st-loading :loading="fLoading" :title="fTitle"></st-loading>
    <st-header
      title="出 库"
      :back-able="true"
      :close-able="true"
    >
      <template slot="header-right">
        <!-- <span>
          更多
        </span> -->
      </template>
    </st-header>

    <div class="tab-content">
      <div class="st-list-box pan-1">
        <div class="st-list">
          <div class="st-list-top">
            <div class="t-tit">{{ info.ordercode }}</div>
          </div>
          <div class="st-list-main">
            <p>订单类型： {{ info.type_text }}订单</p>
						<p>客户： {{ info.receiver }}</p>
						<p>物流方式： {{ info.shippingmethods_text }}</p>
            <div class="upload-filed">
              <div style="float: left;">销售订单：</div>
              <st-file-upload v-model="info['order_file_arr']"></st-file-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="st-list-box pan-1">
        <div class="st-list" v-for="(v, i) in info.skus">
          <div class="st-list-top">
            <div class="t-tit">SKU： {{ v.sku }}</div>
            <div class="t-status"></div>
          </div>
          <div class="st-list-main">
            <p>品&emsp;&emsp;牌：{{ v.brand }}</p>
            <p>型&emsp;&emsp;号：{{ v.model }}</p>
						<p>销售数量：{{ v.total }}</p>
            <p>已&nbsp;&nbsp;出 库：{{ v.outstocknum }}</p>
            <p>待&nbsp;&nbsp;出 库：{{ v.unoutstocknum }}</p>
           
						<st-form-item label="库存流水:" :prop="`items.${i}.inventorylog_id`">
							<st-select
							  v-model="info['skus'][i]['inventorylog_id']"
							  name="inventorylog_id"
							  placeholder="请选择库存流水"
							  :options="(obj, params) => { return getInventoryLog(params, info['skus'][i]); }"
								@change="inventorylogChange(i)"
							>
							</st-select>
						</st-form-item>
						
						<st-form-item label="出库数量:" :prop="`items.${i}.num`">
						  <van-field
								clearable
						    class="st-form-item-input"
						    v-model="info['skus'][i]['num']"
						    name="出库数量:"
						    label=""
						    placeholder="请输入出库数量"
						  />
						</st-form-item>
            
          </div>
        </div>
      
				<p  class="st-van-btn-primary-p">
				  <van-button class="st-van-btn-primary" @click="submit()">
				    提&emsp;交
				  </van-button>
				</p>
			</div>
    </div>


  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StHeader from "@/components/layout/Header.vue";
import StLoading from "@/components/layout/FullLoading.vue";
import StSelect from "@/components/Select.vue";
import { getWarehouse } from "@/views/Sto/purchase/conf/options";
import StFormItem from "@/components/formItem.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    "st-header": StHeader,
    'st-select': StSelect,
    "st-loading": StLoading,
		"st-form-item": StFormItem,
  },
  props: {  },
  data() {
    return {
      fLoading: false, // 全屏加载
      fTitle: "提交中",
      info: {},
      formDataText: {},
      options: {
        getWarehouse
      },
    };
  },
  watch: {},
	created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.getInfo();
    },
		// 库存流水 更改
		inventorylogChange(index) {
			if (!this.info.skus[index].num) {
				this.info.skus[index].num = this.info.skus[index].unoutstocknum;
			}
		},
    // 获取详情 
    getInfo() {
      this.$post(this.$api.stGetXiaoshouoDetail, {id: this.$route.params.id}).then((res) => {
      	if (res.code == 200) {
					res.data.skus = res.data.skus.map((v) => { v.num = ''; 
						return v;
					});
      		this.info = res.data;
      	} else {
      		this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
      	}
      	this.loading = false;
      });
    },
		
		// 获取库存流水
		getInventoryLog(params, product) {
			let query = {
				page: params.page,
				query: params.query,
				ordercode: this.info.ordercode,
				custom: {
					'products_id': product.products_id,
					'customer': this.info.clientid,
				},
			}
			
			return this.$option.getInventoryLog(this, query);
		},

    /* 出库 提交到接口
    * proId 产品id
    */ 
    submit() {
      this.fLoading = true;
			let skus = JSON.parse(JSON.stringify(this.info.skus));
			let order_file_arr = JSON.parse(JSON.stringify(this.info.order_file_arr));
      let formData = {
				ids: this.$route.params.id,
				order_file: order_file_arr.map((v) => { return v.url }).join(','),
				skus: skus.map((v) => { 
					v.outstocknum = v.num ? v.num : 0;
					v.inventorylog_id = v.inventorylog_id ? v.inventorylog_id : '';
					return v;
				}),
			};

      this.$post(this.$api.stSaleSendgoods, formData).then((res) => {
        if (res.code !== 1) {
          this.$toast.fail(res.msg ? res.msg : '提交请求异常，请稍后重试！');
          this.fLoading = false;
        } else {
          this.$toast.success('提交成功');
					this.fLoading = false;
					this.$router.replace('/saleo/list');
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.upload-filed {
  overflow: hidden;
  /deep/ .avatar-uploader {
    float: left;
  }  
}

.out-wrap {
	position: relative;
	.st-list {
	  padding: 30px;
		margin: 24px;
		border-radius: 5px;
	}
	
	.st-van-btn-primary-p {
		position: sticky;
		bottom: 10px;
		
		.st-van-btn-primary {
			position: relative;
			left: 50%;
			transform: translateX(-50%);
		  width: 80%;
		}
	}
	
}

.van-field {
	box-shadow: inset 0 0 0 2px rgb(223,223,223);
	border-radius: 5px;
}

</style>
